import styled from "styled-components";
import { MainInner, responsiveFontSizeM } from "@/styles/global";

const FundTabsWrapper = styled(MainInner)`
    margin: 0 auto;
    padding: 0;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;
    padding: 10px 24px;
  }
`;

const FundTabContainer = styled.div`
    position: relative;
    padding: 0;
    margin: 0 auto;
    max-width: 100%;
    margin: 0 auto;
    
    @media (max-width: 768px) {
        &:before {
            content: "";
            position: absolute;
            width: 50px;
            height: 100%;
            background: linear-gradient(
                to left,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 0) 100%
            );
            top: 0;
            right: 0;
            z-index: 2;
            pointer-events: none;
        }
    }
`;

const FundTabsTab = styled.div<{ isActive: boolean }>`
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.fundTabBG};
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    color: ${({ theme }) => theme.colors.primary};
    font-family: "Open Sans";
    text-transform: uppercase;
    ${responsiveFontSizeM}
    font-weight: 600;
    letter-spacing: 0.27px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    gap: 8px;
    border: 1px solid ${({ theme }) => theme.colors.fundTabBG};

    @media (max-width: 768px) {
        padding: 16px 24px;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.darkBlue};
        color: ${({ theme }) => theme.colors.white};
        svg {
            path {
                fill: ${({ theme }) => theme.colors.white};
            }
        }
    }

    ${({ isActive, theme }) => isActive && `
        background-color: ${theme.colors.darkBlue};
        color: ${theme.colors.white};
    `}
`;

const FundTabsTabLink = styled(FundTabsTab).attrs(() => ({ as: "a" }))`
    text-decoration: none;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.colors.primary};

    svg {
        @media (max-width: 768px) {
            height: 20px;
        }
    }
`;

const FundTabSeperator = styled.div`
    width: 1px;
    height: 67px;
    border: 0.5px solid ${({ theme }) => theme.colors.stroke};
    display: flex;

    @media (max-width: 768px) {
        height: 51px;
    }
`;

const S = {
  FundTabsWrapper,
  FundTabContainer,
  FundTabsTab,
  FundTabsTabLink,
  FundTabSeperator,
};

export default S;
